import classes from './Loading.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function Loading(props) {
  let { size, invert, className } = props;

  return (
    <div className={cn(classes.container, className)}>
      <div
        className={cn(classes.loading, classes[size], {
          [classes.invert]: invert
        })}
      >
        <div className={classes.line} />
        <div className={classes.line} />
        <div className={classes.line} />
        <div className={classes.line} />
        <div className={classes.line} />
      </div>
    </div>
  );
}

Loading.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['big', 'normal', 'small']),
  invert: PropTypes.bool
};

Loading.defaultProps = {
  size: 'normal'
};

export default Loading;
